"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LOADER_LOADING_MESSAGE = void 0; // Elements Component

var LOADER_LOADING_MESSAGE = function LOADER_LOADING_MESSAGE(loadingMessage) {
  return "".concat(loadingMessage) ? "".concat(loadingMessage) : "Loading....";
};

exports.LOADER_LOADING_MESSAGE = LOADER_LOADING_MESSAGE;
var _default = {
  LOADER_LOADING_MESSAGE: LOADER_LOADING_MESSAGE
};
exports["default"] = _default;